import { Component } from "@angular/core";
import { Globals } from "../../services/globals";

@Component({
  templateUrl: "inspiration-overview.component.html",
  styleUrls: ["inspiration-overview.component.css"]
})

export class InspirationOverviewComponent {

  constructor(public globals: Globals) {
    this.globals.hideHeader = true;
  }

  ngOnInit() {
    this.globals.validateSession();
  }

  indexChanged(event: Event) {

  }
}
